/**
 * Each members tab is a distinct list with its own search term, sort and filters, so switching
 * tabs starts from a clean query rather than carrying the previous list's state over. Only the
 * header Location filter survives: it sits outside the per-list filter popover, is persisted
 * per organization and scopes every list.
 */
const PRESERVED_PARAMS = ['state'];

export const getTabSearchParams = (prev: URLSearchParams, listVersion: string) => {
    const next = new URLSearchParams();

    PRESERVED_PARAMS.forEach((param) => {
        const value = prev.get(param);
        if (value) {
            next.set(param, value);
        }
    });

    // The active list is the default — it has no `list_version`.
    if (listVersion !== 'active') {
        next.set('list_version', listVersion);
    }

    return next;
};
